export default __webpack_public_path__ + "static/media/charticon.63926897.png";